import React, { useState, useEffect } from 'react'
import {
  Grid,
  TextField,
  IconButton,
  Tooltip,
  List,
  ListItem,
  ListItemText,
  Link,
  Button,
  Typography,
  Paper,
  Box,
  Container
} from '@material-ui/core'
import LambdaFetch from '../functions/FetchFromLambda'
import LoadingButton from '../components/LoadingButton'
import { ContentCopy } from '@mui/icons-material'

export default function UserAccount(props) {
  const [state, setstate] = useState({
    isLoading: false,
    isFetched: false
  })
  const [clientVals, setClientVals] = useState({
    exportAccessKey: null,
    exportSecretKey: null,
    exportSessionToken: null,
    exportRegion: null,
    ec2InstanceId: null,
    ec2InstanceAvailabilityZone: null,
    rdsEndpoint: null
  })
  const [credentials, setCredentials] = useState({
    host: '',
    port: '',
    username: '',
    password: ''
  })
  const [copiedField, setCopiedField] = useState('')

  const fetchData = async () => {
    try {

      setstate({ ...state, isLoading: true, isFetched: false })
      const resp = await LambdaFetch(
        'user-account',
        'post',
        props.fetchInitialData.credentials.user.accessToken,
        JSON.stringify({
          action: 'get-db-credentials'
        }),
        '',
        props.fetchInitialData.credentials
      )

      const {
        accessKeyId,
        secretAccessKey,
        sessionToken,
        availabilityZone,
        dbUserName,
        dbUserPassword,
        instanceId,
        rdsEndpoint,
        region,
      } = resp.data.exports

      setClientVals({
        exportAccessKey: accessKeyId,
        exportSecretKey: secretAccessKey,
        exportSessionToken: sessionToken,
        exportRegion: region,
        ec2InstanceId: instanceId,
        ec2InstanceAvailabilityZone: availabilityZone,
        rdsEndpoint: rdsEndpoint,
      })

      setCredentials({
        host: '127.0.0.1',
        port: '3388',
        username: dbUserName,
        password: dbUserPassword
      })
      setstate({ ...state, isLoading: false, isFetched: true })

    } catch (e) {
      console.log(e)
      setstate({ ...state, isLoading: false, isFetched: false })

    }
  }
  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text)
    setCopiedField(field)
    setTimeout(() => setCopiedField(''), 2000) // Clear copied message after 2 seconds
  }

  const {
    exportAccessKey,
    exportSecretKey,
    exportSessionToken,
    exportRegion,
    ec2InstanceId,
    ec2InstanceAvailabilityZone,
    rdsEndpoint
  } = clientVals

  const textFields = {
    exports: `export AWS_ACCESS_KEY_ID=${exportAccessKey}
export AWS_SECRET_ACCESS_KEY=${exportSecretKey}
export AWS_SESSION_TOKEN=${exportSessionToken}
export AWS_REGION=${exportRegion}`,
    tempPem: `cd /tmp 
ssh-keygen -f apix_rds_rsa`,
    sendKey: `aws ec2-instance-connect send-ssh-public-key \
--instance-id ${ec2InstanceId} \
--availability-zone ${ec2InstanceAvailabilityZone} \
--instance-os-user ec2-user \
--ssh-public-key file:///tmp/apix_rds_rsa.pub`,
    startSsm: `aws ssm start-session \
--target ${ec2InstanceId} \
--document-name AWS-StartPortForwardingSession \
--parameters '{"portNumber":["22"], "localPortNumber":["9999"]}'`,
    ssh: `ssh -i/tmp/apix_rds_rsa ec2-user@localhost \
-p 9999 \
-N \
-L 3388:${rdsEndpoint}:3306`
  }
  return (
    <Container maxWidth='lg' style={{ marginTop: '2rem' }}>

      {/* {credentials.username && credentials.password && ( */}
      <Paper elevation={3} style={{ marginTop: '1rem', padding: '1rem' }}>
        <Typography variant='h4' gutterBottom>
          Database Access Credentials
        </Typography>
        <Box sx={{ mb: 0 }}>
          <Typography variant="h6" gutterBottom>
            💡 Before You Begin
          </Typography>

          <List>
            <ListItem>
              <ListItemText
                primary={
                  <>
                    ✅ <strong>AWS CLI installed</strong> on your machine. If not, follow the official install guide here:{' '}
                    <Link
                      href="https://docs.aws.amazon.com/cli/latest/userguide/install-cliv2.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      AWS CLI Install Guide
                    </Link>
                  </>
                }
              />
            </ListItem>

            <ListItem>
              <ListItemText
                primary={
                  <>
                    ✅ <strong>Two terminal windows</strong>:
                    <List sx={{ pl: 4, pt: 1 }}>
                      <ListItem disableGutters>
                        <ListItemText primary="• Terminal 1 — for Steps 1–4 (setup and session start)." />
                      </ListItem>
                      <ListItem disableGutters>
                        <ListItemText primary="• Terminal 2 — open a new window for Step 5 (SSH tunnel)." />
                      </ListItem>
                    </List>
                  </>
                }
              />
            </ListItem>
          </List>

          <LoadingButton
            label='Get Access'
            isLoading={state.isLoading}
            color='primaryVLButton'
            fn={() => fetchData()}
          />
        </Box>

        {state.isFetched && (
          <>
            <h5 style={{ marginTop: "1.5rem" }}>Step 1: Clear any existing AWS credentials</h5>
            {displayField({
              cur: 'exports',
              copiedField,
              value: textFields.exports,
              handleCopy
            })}
            <h5 style={{ marginTop: "1.5rem" }}>Step 2: Generate a new SSH key in local tmp folder</h5>
            {displayField({
              cur: 'tempPem',
              copiedField,
              value: textFields.tempPem,
              handleCopy
            })}
            <h5 style={{ marginTop: "1.5rem" }}>Step 3: Push your public SSH key to the EC2 instance</h5>
            {displayField({
              cur: 'sendKey',
              copiedField,
              value: textFields.sendKey,
              handleCopy
            })}

            <h5 style={{ marginTop: "1.5rem" }}>Step 4: Start a port forwarding session via AWS SSM</h5>
            {displayField({
              cur: 'startSsm',
              copiedField,
              value: textFields.startSsm,
              handleCopy
            })}
            <h5 style={{ marginTop: "1.5rem" }}>Step 5: Go to 2nd terminal. SSH into the EC2 instance locally with port forwarding</h5>

            {displayField({
              cur: 'ssh',
              copiedField,
              value: textFields.ssh,
              handleCopy
            })}

            <h5 style={{ marginTop: "1.5rem" }}>Step 6: Connect to the RDS database using the following credentials</h5>
            {Object.keys(credentials).map(cur => {
              return (
                <>
                  <Box display='flex' alignItems='center' marginTop={1}>
                    <TextField
                      label={cur}
                      variant='outlined'
                      fullWidth
                      size='small'
                      value={credentials[cur]}
                      InputProps={{
                        readOnly: true
                      }}
                      style={{ marginRight: '0.5rem' }}
                    />
                    <Tooltip title='Copy Password'>
                      <IconButton
                        onClick={() =>
                          handleCopy(credentials[cur], cur)
                        }
                        aria-label={`copy ${cur} `}
                        color='primary'
                      >
                        <ContentCopy />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  {copiedField === cur && (
                    <Typography
                      variant='body2'
                      color='success.main'
                      style={{ marginTop: '0.5rem' }}
                    >
                      {`${cur} copied to clipboard!`}
                    </Typography>
                  )}
                </>
              )
            })}
          </>
        )}
      </Paper>
    </Container>
  )
}


const displayField = (props) => {
  const { value, cur, copiedField, handleCopy } = props
  return (
    <>
      <Box display='flex' alignItems='center' marginTop={1}>
        <TextField
          // label={cur}
          variant='outlined'
          fullWidth
          size='small'
          multiline
          value={value}
          InputProps={{
            readOnly: true
          }}
          style={{ marginRight: '0.5rem' }}
        />
        <Tooltip title='Copy Password'>
          <IconButton
            onClick={() =>
              handleCopy(value, cur)
            }
            aria-label={`copy ${cur} `}
            color='primary'
          >
            <ContentCopy />
          </IconButton>
        </Tooltip>
      </Box>
      {copiedField === cur && (
        <Typography
          variant='body2'
          color='success.main'
          style={{ marginTop: '0.5rem' }}
        >
          {`${cur} copied to clipboard!`}
        </Typography>
      )}
    </>
  )
}
